
<h1>{{getLabelValue('Title') | striphtml}}</h1>
<p [innerHTML]="getLabelValue('TitleDescription') | safe: 'html'"></p>



